import { render, staticRenderFns } from "./CollectionRequest.vue?vue&type=template&id=f2efd2ae&scoped=true&"
import script from "./CollectionRequest.vue?vue&type=script&lang=ts&"
export * from "./CollectionRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2efd2ae",
  null
  
)

export default component.exports